import {
  FETCH_ALL_TRAININGS,
  CREATE_TRAININGS,
  DELETE_TRAININGS,
  UPDATE_TRAININGS,
} from '../constants/actionTypes';
import * as api from '../api/index.js';

export const getTrainings = () => async (dispatch) => {
  try {
    const { data } = await api.fetchTrainings();

    dispatch({ type: FETCH_ALL_TRAININGS, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const createTraining = (training) => async (dispatch) => {
  try {
    const { data } = await api.createTraining(training);

    dispatch({ type: CREATE_TRAININGS, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const deleteTraining = (id) => async (dispatch) => {
  try {
    await api.deleteTraining(id);

    dispatch({ type: DELETE_TRAININGS, payload: id });
  } catch (error) {
    console.log(error.message);
  }
};

export const updateTraining = (id, training) => async (dispatch) => {
  try {
    const { data } = await api.updateTraining(id, training);

    dispatch({ type: UPDATE_TRAININGS, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};
